import React, { useState } from 'react';

import Loader from '../../../../../../../../../surveys/components/SurveyBuilderPage/Loader/Loader';
import SliderAnswerRangesPopup from './components/SliderAnswerRangesPopup';

export default ({ question, surveyRefetch }) => {
  const [
    showSliderAnswerRangesPopup,
    setShowSliderAnswerRangesPopup
  ] = useState(false);

  const isLoading = false;

  return (
    <>
      {isLoading ? <Loader /> : null}
      <span
        role="presentation"
        className="expand-open-question-button"
        onClick={() => setShowSliderAnswerRangesPopup(true)}
      >
        Manage numeric ranges
      </span>
      {showSliderAnswerRangesPopup ? (
        <SliderAnswerRangesPopup
          setShowSliderAnswerRangesPopup={setShowSliderAnswerRangesPopup}
          question={question}
          surveyRefetch={surveyRefetch}
        />
      ) : null}
    </>
  );
};
